module.exports = __webpack_public_path__ + "img/vita_tea_photo.4f230f26.png";